import React, {useState} from 'react'
import {ActionsCell} from '../../../componet/Menu'
import {Avatar, Box, Stack} from '@mui/material'
import Edit from './Edit'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import Switch from '../../../componet/Toastr/Switch'
import Media from '../../../Api/media'
import SimpleLoading from '../../customTable/SimpleLoading'
import PupUpImage from '../../customTable/PupUpImage'
import NameText from '../../customTable/NameText'
import Image from '../../customTable/Image'

export default function Row({
  item,
  i,
  setIsLoading,
  rows,
  setRows,
  setNum,
  setAdded,
}: {
  item: any
  i: number
  setIsLoading: any
  rows: any
  setRows: any
  setNum: any
  setAdded: any
}) {
  const [state, setState] = useState(item.status)
  const [open, setOpen] = React.useState(false)
  const [editItem, setEditItem] = useState(item)
  const handelEdit = () => {
    setOpen(true)
  }
  const [isLoading, setIsLoadingStatus] = useState(false)
  const handleStatusChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    Media.putStatus(
      item.id,
      state === 1 ? 0 : 1,
      () => {
        setRows((prev: any) =>
          [
            ...prev.filter((e: any) => e.id != item.id),
            {...editItem, status: state === 1 ? 0 : 1},
          ].sort((a, b) => b.id - a.id)
        )
        setState(state === 1 ? 0 : 1)
      },
      setIsLoadingStatus
    )
  }
  const [isDeleted, setDeleted] = useState(true)
  const [isLoadingDelete, setIsLoadingDelete] = useState(false)
  const handelDelete = () => {
    setAdded(false)

    Media.delete(
      item.id,
      (res: any) => {
        setNum((prev: any) => prev - 1)
        setAdded(!false)

        setRows((prev: any) => prev.filter((e: any) => e.id !== item.id))
        setIsLoading(!true)
      },
      setIsLoadingDelete
    )
  }
  const store = useSelector((state: RootState) => state.vender)

  return (
    <>
      {isDeleted && (
        <>
          {' '}
          <tr className='fw-bold text-muted '>
            <td>
              <a className='text-dark fw-bold text-hover-primary fs-6'>{i + 1}</a>
            </td>
            <td style={{textAlign: 'start'}}>
              <NameText text={editItem.title} />
            </td>
            <td style={{textAlign: store.isRtl === 0 ? 'start' : 'start'}}>
              <Stack maxWidth={'120px'}>
                {editItem.type === 'image' ? (
                  <PupUpImage image={editItem.attachment}>
                    <Box sx={{width: '200px', height: '200px'}}>
                      <Image
                        sx={{height: '100%', width: '100%', borderRadius: '8px'}}
                        src={editItem.attachment}
                        alt={editItem.title && editItem.title.slice(0, 15)}
                      />
                    </Box>
                  </PupUpImage>
                ) : (
                  <PupUpImage video image={editItem.attachment}>
                    <video
                      style={{height: '202px', minWidth: '202px'}}
                      controls
                      muted
                      src={editItem.attachment}
                    ></video>
                  </PupUpImage>
                )}
              </Stack>
            </td>
            <td style={{textAlign: 'start'}} className='text-start'>
              {isLoading ? (
                <SimpleLoading />
              ) : (
                <Switch
                  name='status'
                  value={state === 1 ? true : false}
                  handleChange={
                    store.permissions &&
                    store.permissions &&
                    store.permissions.includes('medias_update') &&
                    handleStatusChange
                  }
                />
              )}{' '}
            </td>{' '}
            <td style={{textAlign: 'start'}} className='text-start'>
              {isLoadingDelete ? (
                <SimpleLoading />
              ) : (
                <ActionsCell
                  onEdit={
                    store.permissions &&
                    store.permissions &&
                    store.permissions.includes('medias_update') &&
                    handelEdit
                  }
                  onDelete={
                    store.permissions &&
                    store.permissions &&
                    store.permissions.includes('medias_delete') &&
                    handelDelete
                  }
                  onView={null}
                />
              )}
            </td>
          </tr>
          <Edit
            rows={rows}
            setRows={setRows}
            setItem={setEditItem}
            item={editItem}
            open={open}
            setOpen={setOpen}
          />
        </>
      )}
    </>
  )
}
